import { createContext } from 'react'

import { CellSuccessProps } from '@cedarjs/web'

import {
  GetAppStateQuery,
  GetAppStateQueryVariables,
  OrganizationByPathFragment,
  RecordTypeFragment,
} from '../../../types/graphql'
import { RefetchFnType } from '../../types'

export type AppStateContextLayoutCellProps = CellSuccessProps<
  GetAppStateQuery,
  GetAppStateQueryVariables
>

export type AppStateQueryOrganization = AppStateContextLayoutCellProps['organization']

export interface AppStateContextData {
  user: AppStateContextLayoutCellProps['user']
  organization: AppStateQueryOrganization | undefined
  organizationByPath: OrganizationByPathFragment | undefined
  recordTypes: RecordTypeFragment[]
  currentlyViewedRecordTypeId: number | undefined
  setCurrentlyViewedRecordTypeId: (recordTypeId: number | undefined) => void
  refetch: RefetchFnType
  isLoading: boolean // Whether the app state is still loading
}

export const AppStateContext = createContext<AppStateContextData | undefined>(undefined)
